/*
 * Module for the category header
 */

define([
  "marionette",
  "messaging/messenger",
  "./topicCategoriesHeaderView",
  "modules/topicsSplit/topic/topicResponse/topicCategories/topicCategoriesAddModal/modalViewContainer/modalViewContainerModule",
], function (Marionette, Messenger, TopicCategoriesHeaderView, AddCategoryModule) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "topicCategoriesHeader";
      this.region = options.region;
      this._setUpVents();
    },

    show: function (categories, readOnly) {
      this.categories = categories;
      this.categories.readOnly = readOnly;
      this.layout = new TopicCategoriesHeaderView.headerLayout({ collection: categories });
      // Add Click Listener
      this.layout.on(
        "add:category",
        function () {
          if (categories.allowEditCategoryCodes) {
            const topicId = Messenger.reqres.request("current:topic:id");
            Messenger.vent.trigger("show:modal", AddCategoryModule, {}, this.categories, {
              title: "topic.categories.title",
              closeOnBackgroundClick: false,
              close: true,
              modalWidth: 1000,
              trackInteraction: {
                action: "Add Topic Category",
                id: topicId,
                idType: "Topic",
                object: "Topic",
              },
            });
          }
        },
        this,
      );

      this.showRegion(this.layout);
    },
    _setUpVents: function () {
      //event when a node from the conversation diagram is selected
      Messenger.vent.on(
        "topic:category:list:refresh",
        function (categories) {
          this.show(categories);
        },
        this,
      );
    },
  });
});
